import { render, staticRenderFns } from "./NewUpload.vue?vue&type=template&id=c327f40a&scoped=true"
import script from "./NewUpload.vue?vue&type=script&lang=js"
export * from "./NewUpload.vue?vue&type=script&lang=js"
import style0 from "./NewUpload.vue?vue&type=style&index=0&id=c327f40a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c327f40a",
  null
  
)

export default component.exports